export default __webpack_public_path__ + "static/media/plusCircle.fe29ebfc.svg";